import { RefObject, useCallback, useRef } from 'react';
import "./ripple.linaria.module.css!=!./ripple?./ripple.linaria.module.css?css=H4sIAAAAAAAAA12PvU7EMBCEe56C5iSQcBQDESdT8iCWf/YOJ7HXWm/OBIt3R0FyQzOa0TdTzGA46rjowqmezy1jCRwwKWMLrhvD+8/dcFRk1Yt9S7fvZkoGx4IMB1Sy82nWshQb/GezSB5IkPFhK2oaT73z7LWkF+lq/hebNW65Em7JC4crknIbEST+OEKfL69a5rB/1aVhNi7wrsZh6pRJS0RgmBuTSeWCFNWfWw3Dg5jG09P9oY99EWd9Xfd6iS1jSAwk4AaJi0qYjt+/b5khFRsBAAA="
export const rippleStyles = "atm_mk_stnw88 atm_1w_kb7nvz atm_5j_1ssbidh atm_2d_1r31cwp atm_k4_1piyxwk atm_tr_1ooetej atm_mj_glywfm";
interface AnimateRippleOptions {
  center?: boolean;
  scale?: number;
}
export const animateRipple = (clientX: number, clientY: number, rippleRef: RefObject<HTMLElement | null>, containerRef: RefObject<HTMLElement | null>, options: AnimateRippleOptions = {}) => {
  const {
    center = false,
    scale = 1.75
  } = options;
  const container = containerRef.current;
  const ripple = rippleRef.current;
  if (!container || !ripple) return;
  const rect = container.getBoundingClientRect();
  const size = rect.width * scale;
  ripple.animate?.([{
    opacity: 0.5,
    width: 0,
    height: 0
  }, {
    opacity: 0,
    width: `${size}px`,
    height: `${size}px`
  }], {
    duration: 380,
    iterations: 1
  });
  ripple.style.left = center ? '50%' : `${clientX - rect.x}px`;
  ripple.style.top = center ? '50%' : `${clientY - rect.y}px`;
};

// pointerdown, not click: a label forwards a second click from the control
export const useCenterRipple = (disabled = false) => {
  const rippleRef = useRef<HTMLSpanElement>(null);
  const containerRef = useRef<HTMLSpanElement>(null);
  const onPointerDown = useCallback(() => {
    if (disabled) return;
    animateRipple(0, 0, rippleRef, containerRef, {
      center: true,
      scale: 1.2
    });
  }, [disabled]);
  return {
    rippleRef,
    containerRef,
    onPointerDown
  };
};